const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// .trim() é usado para remover espaços em branco no início e no final da string, 
// garantindo que o campo de email não seja considerado vazio apenas por conter espaços.

export function validateEmail(email) {
  if (!String(email || '').trim()) return 'O email é obrigatório.';
  if (!EMAIL_REGEX.test(String(email || '').trim())) return 'Formato de email inválido.';
  return '';
}

export function validateOptionalEmail(email) {
  if (!email) return '';
  if (!EMAIL_REGEX.test(String(email).trim())) return 'Formato de email inválido.';
  return '';
}

export function validatePassword(password) {
  if (!password) return 'A senha é obrigatória.';
  if (password.length < 6) return 'A senha deve ter no mínimo 6 caracteres.';
  return '';
}

export function validateConfirmPassword(password, confirm) {
  if (!confirm) return 'Confirme sua senha.';
  if (password !== confirm) return 'As senhas não coincidem.';
  return '';
}
